import { Model } from 'caldera-immutable-model';

export default class User extends Model {
  getId() { return this.id; } // For backwards compatibility
  get id(): number { return this.get('uid'); }
  get uid(): number { return this.get('uid'); }
  get email(): string { return this.get('email'); }
  get username(): string { return this.get('username'); }
  get name(): string { return this.get('name'); }
  get firstName(): string { return this.get('firstName'); }
  get lastName(): string { return this.get('lastName'); }
  get avatarURL(): string { return this.get('avatarURL'); }
  get notificationsEnabled(): boolean { return !!this.get('notificationsEnabled'); }
  get isPremium(): boolean { return !!this.get('isPremium'); }
  get customerId(): number { return this.get('customerId'); }
  get planId(): number { return this.get('planId'); }
  get subscriptionId(): number { return this.get('subscriptionId'); }
  get timezone(): string { return this.get('timezone'); }
}



// WEBPACK FOOTER //
// ./src/models/User.js